import { render, staticRenderFns } from "./NecessityStrengthGoalList.vue?vue&type=template&id=11365c01&scoped=true"
import script from "./NecessityStrengthGoalList.vue?vue&type=script&lang=js"
export * from "./NecessityStrengthGoalList.vue?vue&type=script&lang=js"
import style0 from "./NecessityStrengthGoalList.vue?vue&type=style&index=0&id=11365c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11365c01",
  null
  
)

export default component.exports